<template>
    <div class="zoho-forward-settings">
        <div class="mode-card">
            <div class="title">
                <div class="title-content">
                    <ZohoIcon class="zoho-icon" />
                    <div>
                        <div class="title-text">{{ $t("message.autoTransfer") }}</div>
                        <div class="subtitle">
                            {{ $t("message.autoTransferDescription") }}
                        </div>
                    </div>
                </div>
                <a-switch
                    class="md-warning ml-3"
                    checked-children="✔"
                    un-checked-children="✖"
                    :checked="isZohoForwardEnabled()"
                    @change="toggleZohoForward"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import ZohoIcon from "../Chatbot/pages/integrations/svg/ZohoIcon.vue";
import { mapState } from "vuex";

export default Vue.extend({
    name: "ZohoForwardSettings",
    components: {
        ZohoIcon,
    },
    props: {
        channel: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    computed: {
        ...mapState({
            zohoChannels: (state) => state.channel.channels.filter((channel) => channel.type === "zoho"),
        }),
    },
    methods: {
        isZohoForwardEnabled() {
            return !!this.channel.zohoForward?.enabled;
        },
        async toggleZohoForward(checked) {
            if (checked && this.zohoChannels.length === 0) {
                this.$confirm({
                    title: this.$t("message.zohoChannelRequiredTitle"),
                    content: this.$t("message.zohoChannelRequiredContent"),
                    okText: this.$t("message.okText"),
                    cancelText: this.$t("message.cancelText"),
                    onOk: () => {
                        this.$router.push("/integrations/zoho");
                    },
                });
                return;
            }

            const zohoForward = this.channel.zohoForward || {};
            this.$set(this.channel, "zohoForward", {
                ...zohoForward,
                enabled: checked,
            });
        },
    },
});
</script>

<style scoped lang="scss">
.zoho-forward-settings {
    margin-top: 20px;

    .mode-card {
        width: 100%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;

        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 10px;

            .title-content {
                display: flex;
                align-items: center;

                .zoho-icon {
                    width: 100px;
                    margin-right: 12px;
                }

                .title-text {
                    font-size: 18px;
                    font-weight: 700;
                    color: var(--color-text-strong-default);
                }

                .subtitle {
                    font-size: 14px;
                    color: var(--color-text-strong-default);
                }
            }
        }
    }
}
</style>
